import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { ViewTableModule } from '@nrwl/view-table';
import { ViaviTabulatorModule } from '../../../viavi-tabulator/src/index';
import { AddUnmanagedDeviceComponent } from './components/unmanaged-devices/add-unmanaged-device/add-unmanaged-device.component';
import { DatasourceEntityComponent } from './components/datasource.entity.widget/datasource.entity.component';
import { DownloadAgentComponent } from './components/managed-devices/download.agent/download.agent.component';
import { UnmanagedDeviceListComponent } from './components/unmanaged-devices/unmanaged-device-list/unmanaged-device-list.component';
import { ImportDevicesComponent } from './components/unmanaged-devices/import.devices/import.devices.component';
import { agentProxyComponent } from './components/managed-devices/agent.proxy/proxy.component';
import { EditManagedDeviceComponent } from './components/managed-devices/edit-managed-device/edit-managed-device.component';
import { AgentSpecComponent } from './components/managed-devices/agent-spec/agent-spec.component';
import { JmepConfigureManagementComponent } from './components/jmep/configure/jmep-configure-management/jmep-configure-management.component';
import { JmepV2ConfigureManagementComponent } from './components/jmep/configure/jmepv2-configure-management/jmepv2-configure-management.component';
import { ApplicationManagementModule } from '@nrwl/application-management';
import { AppsMultiStepSetupService } from '../../../common-lib/src/lib/services/multistep/multi-step-setup.service';
import { EndpointsManagementComponent } from './components/endpoints-management/endpoints-management.component';
import { TwampReflectorComponent } from './components/endpoints-management/twamp-reflector/twamp-reflector.component';
import { JmepReflectorComponent } from './components/endpoints-management/jmep-reflector/jmep-reflector.component';
import { UploadsSettingsComponent } from './components/uploads-settings/uploads-settings.component';
import { JmepDiscoverDialogComponent } from './components/jmep/discover/jmep-discover-dialog/jmep-discover-dialog.component';
import { BroadcastDiscoveryComponent } from './components/jmep/discover/broadcast-discovery/broadcast-discovery.component';
import { ZeroTouchDiscoveryComponent } from './components/jmep/discover/zero-touch-discovery/zero-touch-discovery.component';
import { AutoConfigurationComponent } from './components/jmep/discover/auto-configuration/auto-configuration.component';
import { BulkRenamingDialogComponent } from './components/uploads-settings/bulk-renaming-dialog/bulk-renaming-dialog.component';
import { DataDisplayDialogComponent } from './components/uploads-settings/data-display-dialog/data-display-dialog.component';
import { ViewResultsDialogComponent } from './components/uploads-settings/view-results-dialog/view-results-dialog.component';
import { DownloadsSettingsComponent } from './components/downloads-settings/downloads-settings.component';
import { ReportsSettingComponent } from './components/reports-setting/reports-setting.component';
import { TrafficResultsComponent } from './components/traffic-results/traffic-results.component';
import { TransferDeviceComponent } from './components/transfer-device/transfer-device.component';
import { AlarmsDialogComponent } from './components/managed-devices/alarms-dialog/alarms-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    CommonMaterialModule,
    ViewTableModule,
    CommonLibModule,
    FormsModule,
    ReactiveFormsModule,
    ViaviTabulatorModule,
    ApplicationManagementModule
  ],

  declarations: [
    DatasourceEntityComponent,
    DownloadAgentComponent,
    agentProxyComponent,
    AgentSpecComponent,
    AddUnmanagedDeviceComponent,
    EditManagedDeviceComponent,
    JmepConfigureManagementComponent,
    JmepV2ConfigureManagementComponent,
    ImportDevicesComponent,
    UnmanagedDeviceListComponent,
    EndpointsManagementComponent,
    UploadsSettingsComponent,
    TwampReflectorComponent,
    JmepReflectorComponent,
    DownloadsSettingsComponent,
    UploadsSettingsComponent,
    JmepDiscoverDialogComponent,
    BroadcastDiscoveryComponent,
    ZeroTouchDiscoveryComponent,
    AutoConfigurationComponent,
    BulkRenamingDialogComponent,
    DataDisplayDialogComponent,
    ViewResultsDialogComponent,
    DownloadsSettingsComponent,
    ReportsSettingComponent,
    TrafficResultsComponent,
    TransferDeviceComponent,
    AlarmsDialogComponent
  ],

  providers: [AppsMultiStepSetupService],
  exports: [
    DatasourceEntityComponent,
    DownloadAgentComponent,
    agentProxyComponent,
    AddUnmanagedDeviceComponent,
    EditManagedDeviceComponent,
    JmepConfigureManagementComponent,
    JmepV2ConfigureManagementComponent
  ]
})
export class DataSourceManagementModule {}
